import { hasOwn } from './hasOwn';
/**
 * Verify if the provided unknown object is empty
 *
 * Check the test cases for the assumptions
 *
 * @param obj - An object to be tested
 */
export const isEmpty = (obj) => {
    if (Array.isArray(obj)) {
        return obj.length === 0;
    }
    if (typeof obj === 'object' && obj !== null) {
        for (const key in obj) {
            if (hasOwn(obj, key)) {
                return false;
            }
        }
        return true;
    }
    return !obj;
};
//# sourceMappingURL=isEmpty.js.map